(function () {
  if (window.__buyNowInit) return;
  window.__buyNowInit = true;

  function syncWithAddToCart(buyNowButton) {
    var form = buyNowButton.closest('form');
    if (!form) return;

    var addToCartButton = form.querySelector('[data-add-to-cart]');
    if (!addToCartButton) return;

    var sync = function () {
      buyNowButton.disabled = addToCartButton.disabled;
    };

    sync();
    new MutationObserver(sync).observe(addToCartButton, { attributes: true, attributeFilter: ['disabled'] });
  }

  document.querySelectorAll('[data-buy-now]').forEach(syncWithAddToCart);

  function getCartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  }

  function setLoading(button, isLoading) {
    button.classList.toggle('btn--loading', isLoading);
    button.disabled = isLoading;
  }

  function showError(form, message) {
    var existing = form.querySelector('.errors');
    if (existing) existing.remove();

    var errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');
    errorDiv.textContent = message;
    form.append(errorDiv);
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-buy-now]');
    if (!button) return;

    var form = button.closest('form');
    if (!form || button.disabled) return;

    evt.preventDefault();
    setLoading(button, true);

    fetch(getCartAddUrl(), {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status === 422) {
          setLoading(button, false);
          showError(form, result.data.description || result.data.message || 'Não foi possível adicionar o produto ao carrinho.');
          return;
        }

        // O tema usa um checkout de terceiro (Yampi/Dooki) que intercepta a
        // página /cart e redireciona pro checkout real deles — por isso não
        // mandamos direto pro /checkout nativo da Shopify aqui.
        window.location.href = '/cart?ref=buy_now_button';
      })
      .catch(function () {
        setLoading(button, false);
        showError(form, 'Não foi possível adicionar o produto ao carrinho.');
      });
  });
})();
